import React, { Component, useState } from "react";
import axios from "axios";

import {
  Box,
  Button,
  Checkbox,
  Column,
  Columns,
  Control,
  Field,
  Icon,
  Input,
  Select,
  Table,
  TextArea,
  Title,
} from "@allxsmith/bestax-bulma";

import CustomerRentalRecord from "./CustomerRentalRecord";
import { useDispatch, useSelector } from "react-redux";
import { createSetContactDataAction } from "../../actions/dataActions";
import { useContactData } from "../../hooks/useContactData";
import {getContactData, getUserData} from "../../state/selectors";
import Spinner from "react-spinner-material/lib";
import ContactInfoSection from "./ContactInfoSection";
import DeleteWarningModal from "../Modal/DeleteWarningModal";
import TypeChangeModal from "./TypeChangeModal";
import Supplier from "./SupplierSection";
import Customer from "./CustomerSection";
import qs from "qs";
import Instruction from "./Instruction";
import shortid from "shortid";
import MovementDetails from "./MovementDetails";
import {formatXeroData, sendXeroData} from "../../utils";
import useSelect from "../../hooks/useSelect";
import InsuranceInfo from "./InsuranceInfo";
import CashSales from "./CashSales";
import Nav from "../Nav/Nav";
import LoadingSpinner from "../Utils/Spinner";
import {ToastContainer, toast} from "react-toastify";
import {useParams, useSearchParams} from "react-router-dom";

function ContactForm({ match, location, endpoint, history }) {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const id = useParams().contact;

  const complete = useContactData(id, 1, searchParams.get("type"));
  const contact = useSelector(getContactData);
  const _vpUser = useSelector(getUserData);
  const _canEditVpCredit = /jason|neil|demo/i.test(JSON.stringify(_vpUser || {}));
  const [modalOpen, setModalOpen] = useState(false);

  const [typeModalOpen, setTypeModalOpen] = useState(false);
  const [targetType, setTargetType] = useState();

  const phoneTypeOptions = [
      {name: "Landline", value: "Phone"},
      {name: "Mobile", value: "Mobile"},
      {name: "Fax", value: "Fax"}
  ]

  const handleChange = e => {
    dispatch(createSetContactDataAction({ [e.target.name]: e.target.value }));
  };

  const onDeactivatedCheck = e => {
    const toUpdate = {
      target: {
        name: e.target.name,
        value: !contact[e.target.name]
      }
    };
    handleChange(toUpdate)
  }


  const handleCheckbox = e => {
    const {name, checked} = e.target
    dispatch(createSetContactDataAction({ [name]: checked }));
  };

  const setType = type => {
    if (!id) {
      dispatch(createSetContactDataAction({ contact_type: type }));
    } else {
      setTargetType(type);
      setTypeModalOpen(true);
    }
    if(type === "SP"){
      dispatch(createSetContactDataAction({partial_contact: false}))
    }
  };

  const setActive = active => {
      dispatch(createSetContactDataAction({ accounts_active: active }));
  };
  // if (queryParams.type) {
  //   dispatch(createSetContactDataAction({ contact_type: queryParams.type }));
  // }

  const addRentalInstruction = e => {
    e.preventDefault();
    dispatch(createSetContactDataAction({
      rental_instructions: contact.rental_instructions.concat({
        key: shortid.generate(),
        text: ""
      })
    }))
  };

  const updateRentalInstructions = (instruction, index) => {
    let newInstructions = [...contact.rental_instructions];
    newInstructions.splice(index, 1, instruction);
    dispatch(createSetContactDataAction({ rental_instructions: newInstructions }));
  };

  const removeRentalInstruction = index => {
    let newInstructions = [...contact.rental_instructions];
    newInstructions.splice(index, 1);
    dispatch(createSetContactDataAction({ rental_instructions: newInstructions }));
  };

  const addWorkshopInstruction = e => {
    e.preventDefault();
    dispatch(createSetContactDataAction({
      workshop_instructions: contact.workshop_instructions.concat({
        key: shortid.generate(),
        text: "",
        on_completion: false
      })
    }))
  };

  const updateWorkshopInstructions = (instruction, index) => {
    let newInstructions = [...contact.workshop_instructions];
    newInstructions.splice(index, 1, instruction);
    dispatch(createSetContactDataAction({ workshop_instructions: newInstructions }));
  };

  const removeWorkshopInstruction = index => {
    let newInstructions = [...contact.workshop_instructions];
    newInstructions.splice(index, 1);
    dispatch(createSetContactDataAction({ workshop_instructions: newInstructions }));
  };

  const handleDelete = e => {
    e.preventDefault();
    const url = endpoint + "contacts/" + contact.id;
    const conf = { method: "delete", url };
    axios(conf).then(response => window.open("/contacts", "_self"));
  };

  const fillCode = (codeName) => {
    const map = {
      workshop_account_code: "02",
      deposit_account_code: "03",
      hire_account_code: "01",
      sale_account_code: "04",
      loan_account_code: "06",
      part_account_code: "05",
      court_account_code: "07",
      movement_account_code: "08"
    }
    const toUpdate = {
      target: {
        name: codeName,
        value: map[codeName]
      }
    };
    handleChange(toUpdate)
  }

  const validator = (data, type) => {
    if(data.partial_contact){
      let codeFields = ['workshop_account_code', 'deposit_account_code', 'hire_account_code', 'sale_account_code', 'loan_account_code', 'part_account_code', 'court_account_code'];
      let valid = true;
      let codeCount = 0
      codeFields.forEach((field) => {
        if (data[field]) {
          codeCount++;
        }
      });
      if (codeCount <= 0) {
        // Only 1 code is needed to make the contact valid
        valid = false;
      }
      if(data.display_name && data.company_email && data.company_phone && data.company_name && data.address_line1 && (valid || data.contact_type === "SP")){
        return true
      } else {
        toast.warning("Display Name, Company Name, Company Phone, Company Email, Street Address and at least 1 Account Code are required", {position: "top-right"})
        return false
      }
    }
    else {
      if (data.contact_type === "SP") {
        let validPhone = !!(data.company_phone && !!data.company_phone_type)
        if (data.company_phone_type === "Phone") {
          validPhone = validPhone && !!data.company_phone_area_code;
        }
        if (data.company_phone_type === "Phone" || data.company_phone_type === "Mobile") {
          validPhone = validPhone && !!data.company_phone_country_code;
        }
        let validAddress = !!(data.address_line1 && data.town && data.region && data.postcode && data.country);
        if (!!data.display_name && !!data.company_email && (!!data.supplier_payment_terms || data.supplier_payment_terms === 0) && validPhone && validAddress) {
              return true
        } else{
          toast.warning("Company Phone, Email, Area Code, Country Code, Address, Town, Region, Postcode, Country and Name, Display Name, Supplier Payment Terms are required", {position: "top-right"})
        }
      } else if (data.contact_type === "CC") {
        let codeFields = ['workshop_account_code', 'deposit_account_code', 'hire_account_code', 'sale_account_code', 'loan_account_code', 'part_account_code', 'court_account_code', 'movement_account_code'];
        let valid = true;
        let codeCount = 0
        codeFields.forEach((field) => {
          if (data[field]) {
            codeCount++;
          }
        });
        if (codeCount <= 0) {
          // Only 1 code is needed to make the contact valid
          valid = false;
        }
        let validPhone = !!(data.company_phone && !!data.company_phone_type)
        if (data.company_phone_type === "Phone") {
          validPhone = validPhone && !!data.company_phone_area_code
        }
        if (data.company_phone_type === "Phone" || data.company_phone_type === "Mobile") {
          validPhone = validPhone && !!data.company_phone_country_code
        }
        let validAddress = !!(data.address_line1 && data.town && data.region && data.postcode && data.country);
        if (!!data.display_name &&
            !!data.company_email &&
            (!!data.payment_term_days || data.payment_term_days === 0) &&
            validPhone &&
            validAddress &&
            valid) {
          return true
        }
        toast.warning("Display Name, Company Information, Payment Term Days and Account Codes are required", {position: "top-right"})
        return false
      }
    }
  };

  const sendData = () => {
    let contacts = formatXeroData(contact, contact.contact_type); // returns array
    let target;
    let promises = []
    if(contact.contact_type === "SP"){
      target = "Supplier"
    }
    else if(contact.contact_type === "CC"){
      target = "Customer"
    }

    contacts.forEach((c) => {
      promises.push(sendXeroData(c, target))
    })
    Promise.all(promises).then((res) => {
      toast.success("All data has been sent to Xero", {position: "top-right"});
    })
    console.log(contacts);
  }

  const handleSubmit = e => {
    e.preventDefault();
    if(validator(contact, contact.contact_type)) {
      const url = contact.id
          ? `${endpoint}contacts/${contact.id}`
          : `${endpoint}contacts`;
      const method = contact.id ? "put" : "post";

      const conf = {
        method: method,
        data: contact,
        url
      };

      axios(conf).then(response => {
        if (contact.id) {
          createSetContactDataAction(response.data);
        } else {
          let contacts = formatXeroData(response.data, response.data.contact_type); // returns array
          let target;
          let promises = []
          if(response.data.contact_type === "SP"){
            target = "Supplier"
          }
          else if(response.data.contact_type === "CC"){
            target = "Customer"
          }
          if(!response.data.partial_contact) {
            contacts.forEach((contact) => {
             promises.push(sendXeroData(contact, target))
            })
            Promise.all(promises).then((res) => {
             toast.success("All data has been sent to Xero", {postition: "top-right"});
            })
            console.log(contacts);
          }
          window.open("/editcontact/" + response.data.id, "_self");
        }
      });
    }
  };

  if (!complete) {
    return (
        <div>
          <Nav/>
          <LoadingSpinner/>
        </div>
    );
  }

  document.title = "Contact - " + (contact.display_name ? contact.display_name : "New");

  // TODO(bestax-migrate): bestax Icon renders from a `name` prop, not children; convert this icon markup by hand
  // TODO(bestax-migrate): `align` — inside a Control use its hasIconsLeft/iconLeft (or right) props instead
  return (
    <div>
      <Nav/>
      <br/>
      <br/>
      <Box>
        <Columns isMultiline>
          <Column>
            <Field>
              <label className="label">Display Name</label>
              <Control>
                <Input
                  type="text"
                  name="display_name"
                  onChange={handleChange}
                  value={contact.display_name}
                  required
                  disabled={!!contact.id}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field className="has-addons">
              <Control>
                <label className="label">Type</label>
                <Button
                  color={contact.contact_type === "CC" ? "primary" : ""}
                  onClick={() => setType("CC")}
                >
                  Customer
                </Button>
                <Button
                  color={contact.contact_type === "SP" ? "primary" : ""}
                  onClick={() => setType("SP")}
                >
                  Supplier
                </Button>
              </Control>
            </Field>
          </Column>
          {contact.contact_type === "CC" &&
          <Column>
            <label className="label">Cash Sale Account</label>
            <Checkbox
              name={"is_cash_sale"}
              checked={contact.is_cash_sale}
              onClick={onDeactivatedCheck}
            />
          </Column>
          }
          <Column>
            <label className="label">Partial Set Up</label>
            <Checkbox
              name={"partial_contact"}
              checked={contact.partial_contact}
              onClick={onDeactivatedCheck}
            />
          </Column>
          <Column>
            <label className="label">Deactivated</label>
            <Checkbox
              name={"deactivated"}
              checked={contact.deactivated}
              onClick={onDeactivatedCheck}
            />
          </Column>
        </Columns>
      </Box>
      <Box>
        <h1 className="title">Contact Info</h1>
        <Columns isMultiline>
          <Column>
            <Field>
              <label className="label label">First Name</label>
              <Control>
                <Input
                  type="text"
                  name="first_name"
                  onChange={handleChange}
                  value={contact.first_name}
                  required
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Last Name</label>
              <Control>
                <Input
                  className="input"
                  type="text"
                  name="last_name"
                  onChange={handleChange}
                  value={contact.last_name}
                  required
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Contact Number</label>
              <Control>
                <Input
                  type="tel"
                  name="contact_number"
                  onChange={handleChange}
                  value={contact.contact_number}
                  required
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <Control>
                <label className="label">Email</label>
                <Input
                  type="email"
                  name="email"
                  onChange={handleChange}
                  value={contact.email}
                />
              </Control>
            </Field>
          </Column>
        </Columns>
      </Box>
      <Box>
          <ContactInfoSection
            contactList={contact.additional_contacts}
            propertyName="additional_contacts"
            includeAddress
            showLicenceInfo
          />
      </Box>
      <InsuranceInfo insuranceList={contact.insurance_info}/>
      <Box>
        <h1 className="title">Company Info</h1>
        <Columns isMultiline>
          <Column>
            <Field>
              <Control>
                <label className="label">Name (*)</label>
                <Input
                  type="text"
                  name="company_name"
                  onChange={handleChange}
                  value={contact.company_name}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <Control>
                <label className="label">Email (*)</label>
                <Input
                  type="email"
                  name="company_email"
                  onChange={handleChange}
                  value={contact.company_email}
                />
              </Control>
            </Field>
          </Column>
        </Columns>
        <Columns isMultiline>
          <Column>
            <label className="label">Phone Type (*)</label>
            <Select
              name={"company_phone_type"}
              value={contact.company_phone_type}
              onChange={handleChange}
            >
              {phoneTypeOptions.map((option) => (
                  <option value={option.value}>{option.name}</option>
              ))}
            </Select>
          </Column>
          {contact.company_phone_type === "Phone" &&
            <Column>
              <label className="label">{contact.partial_contact ? "Area Code" : "Area Code (*)"}</label>
              <Input
                name={"company_phone_area_code"}
                type={"text"}
                value={contact.company_phone_area_code}
                onChange={handleChange}
              />
            </Column>
          }
          {(contact.company_phone_type === "Phone" || contact.company_phone_type === "Mobile") &&
            <Column>
              <label className="label">{contact.partial_contact ? "Country Code" : "Country Code (*)"}</label>
              <Input
                name={"company_phone_country_code"}
                type={"text"}
                value={contact.company_phone_country_code}
                onChange={handleChange}
              />
            </Column>
          }
          <Column>
            <Field>
              <Control>
                <label className="label">Phone Number (*)</label>
                <Input
                  type="text"
                  name="company_phone"
                  onChange={handleChange}
                  value={contact.company_phone}
                />
              </Control>
            </Field>
          </Column>
        </Columns>
        <Columns isMultiline>
          <Column>
            <Field>
              <Control>
                <label className="label">{contact.partial_contact ? "Street Address" : "Street Address (*)"}</label>
                <Input
                  type="text"
                  name="address_line1"
                  onChange={handleChange}
                  value={contact.address_line1}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <Control>
                <label className="label">{contact.partial_contact ? "Town/City" : "Town/City (*)"}</label>
                <Input
                  type="text"
                  name="town"
                  onChange={handleChange}
                  value={contact.town}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <Control>
                <label className="label">{contact.partial_contact ? "Postcode" : "Postcode (*)"}</label>
                <Input
                  type="text"
                  name="postcode"
                  onChange={handleChange}
                  value={contact.postcode}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <Control>
                <label className="label">{contact.partial_contact ? "Region" : "Region (*)"}</label>
                <Input
                  type="text"
                  name="region"
                  onChange={handleChange}
                  value={contact.region}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <Control>
                <label className="label">{contact.partial_contact ? "Country" : "Country (*)"}</label>
                <Input
                  type="text"
                  name="country"
                  onChange={handleChange}
                  value={contact.country}
                />
              </Control>
            </Field>
          </Column>
        </Columns>
        <Columns isMultiline>
          <Column>
            <Field>
              <Control>
                <label className="label">Company Registration Number</label>
                <Input
                  type="text"
                  name="company_registration_no"
                  onChange={handleChange}
                  value={contact.company_registration_no}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <Control>
                <label className="label">VAT Number</label>
                <Input
                  type="text"
                  name="vat_no"
                  onChange={handleChange}
                  value={contact.vat_no}
                />
              </Control>
            </Field>
          </Column>
        </Columns>
      </Box>
      <Box>
        <h1 className="title">Accounts</h1>
        <Columns isMultiline>
          <Column>
            <Field>
              <label className="label">Direct Van Hire Credit Limit</label>
              <Control>
                <Input
                  className="input"
                  type="number"
                  name="direct_van_hire_credit_limit"
                  onChange={handleChange}
                  value={contact.direct_van_hire_credit_limit}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Rapid Fit Credit Limit</label>
              <Control>
                <Input
                  className="input"
                  type="number"
                  name="rapid_fit_credit_limit"
                  onChange={handleChange}
                  value={contact.rapid_fit_credit_limit}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Van Sales Direct Credit Limit</label>
              <Control>
                <Input
                  className="input"
                  type="number"
                  name="van_sales_direct_credit_limit"
                  onChange={handleChange}
                  value={contact.van_sales_direct_credit_limit}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Direct Vehicle Recovery Credit Limit</label>
              <Control>
                <Input
                  className="input"
                  type="number"
                  name="direct_vehicle_recovery_credit_limit"
                  onChange={handleChange}
                  value={contact.direct_vehicle_recovery_credit_limit}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Van Parts Direct Credit Limit</label>
              <Control>
                <Input
                  className="input"
                  type="number"
                  name="van_parts_direct_credit_limit"
                  onChange={handleChange}
                  value={contact.van_parts_direct_credit_limit}
                  disabled={!_canEditVpCredit}
                />
              </Control>
              <p className="help">0 = cash customer; any value = account customer. Editable by Jason or Neil only.</p>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Outstanding Balance</label>
              <Control>
                <Input
                  className="input"
                  type="number"
                  name="outstanding_balance"
                  onChange={handleChange}
                  value={contact.outstanding_balance}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <Control>
                <label className="label">Payment Terms</label>
                <Input
                  type="text"
                  name="payment_terms"
                  onChange={handleChange}
                  value={contact.payment_terms}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <Control>
                <label className="label">Payment Term Days</label>
                <Input
                  type="number"
                  name="payment_term_days"
                  onChange={handleChange}
                  value={contact.payment_term_days}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <Control>
                <label className="label">Payment Method</label>
                <Input
                  type="text"
                  name="payment_method"
                  onChange={handleChange}
                  value={contact.payment_method}
                />
              </Control>
            </Field>
          </Column>
        </Columns>
        <Columns isMultiline>
          <Column>
            <label className="label">Direct Van Hire Credit Usage</label>
            <Input
              name={"direct_van_hire_credit_usage"}
              value={contact.direct_van_hire_credit_usage}
              disabled={true}
            />
          </Column>
          <Column>
            <label className="label">Rapid Fit Credit Usage</label>
            <Input
              name={"rapid_fit_credit_usage"}
              value={contact.rapid_fit_credit_usage}
              disabled={true}
            />
          </Column>
          <Column>
            <label className="label">Van Sales Direct Credit Usage</label>
            <Input
              name={"van_sales_direct_credit_usage"}
              value={contact.van_sales_direct_credit_usage}
              disabled={true}
            />
          </Column>
          <Column>
            <label className="label">Direct Vehicle Recovery Credit Usage</label>
            <Input
              name={"direct_vehicle_recovery_credit_usage"}
              value={contact.direct_vehicle_recovery_credit_usage}
              disabled={true}
            />
          </Column>
          <Column></Column>
          <Column></Column>
          <Column></Column>
          <Column></Column>
        </Columns>
        {contact.contact_type === "CC" &&
        <Columns isMultiline>
          <Column>
            <label className="label">Workshop Account Number</label>
            <Field className={"has-addons"}>
              <Control>
                <Input
                  type="text"
                  name="workshop_account_code"
                  onChange={handleChange}
                  value={contact.workshop_account_code}
                  disabled={true}
                />
              </Control>
              <Button
                  color={"info"}
                  onClick={() => fillCode("workshop_account_code")}
              >
                  Fill
              </Button>
            </Field>
          </Column>
          <Column>
            <label className="label">Part Account Number</label>
            <Field className={"has-addons"}>
              <Control>
                <Input
                  type="text"
                  name="part_account_code"
                  onChange={handleChange}
                  value={contact.part_account_code}
                  disabled={true}
                />
              </Control>
              <Button
                  color={"info"}
                  onClick={() => fillCode("part_account_code")}
              >
                  Fill
              </Button>
            </Field>
          </Column>
          <Column>
            <label className="label">Movement Account Number</label>
            <Field className={"has-addons"}>
              <Control>
                <Input
                  type="text"
                  name="movement_account_code"
                  onChange={handleChange}
                  value={contact.movement_account_code}
                  disabled={true}
                />
              </Control>
              <Button
                  color={"info"}
                  onClick={() => fillCode("movement_account_code")}
              >
                  Fill
              </Button>
            </Field>
          </Column>
          <Column>
            <label className="label">Vehicle Sale Account Number</label>
            <Field className={"has-addons"}>
              <Control>
                <Input
                  type="text"
                  name="sale_account_code"
                  onChange={handleChange}
                  value={contact.sale_account_code}
                  disabled={true}
                />
              </Control>
              <Button
                  color={"info"}
                  onClick={() => fillCode("sale_account_code")}
              >
                  Fill
              </Button>
            </Field>
          </Column>
          <Column>
            <label className="label">Loan Account Number</label>
            <Field className={"has-addons"}>
              <Control>
                <Input
                  type="text"
                  name="loan_account_code"
                  onChange={handleChange}
                  value={contact.loan_account_code}
                  disabled={true}
                />
              </Control>
              <Button
                  color={"info"}
                  onClick={() => fillCode("loan_account_code")}
              >
                  Fill
              </Button>
            </Field>
          </Column>
          <Column>
            <label className="label">Hire Account Number</label>
            <Field className={"has-addons"}>
              <Control>
                <Input
                  type="text"
                  name="hire_account_code"
                  onChange={handleChange}
                  value={contact.hire_account_code}
                  disabled={true}
                />
              </Control>
              <Button
                  color={"info"}
                  onClick={() => fillCode("hire_account_code")}
              >
                  Fill
              </Button>
            </Field>
          </Column>
          <Column>
            <label className="label">Deposit Account Number</label>
            <Field className={"has-addons"}>
              <Control>
                <Input
                  type="text"
                  name="deposit_account_code"
                  onChange={handleChange}
                  value={contact.deposit_account_code}
                  disabled={true}
                />
              </Control>
              <Button
                  color={"info"}
                  onClick={() => fillCode("deposit_account_code")}
              >
                  Fill
              </Button>
            </Field>
          </Column>
          <Column>
            <label className="label">Court Account Number</label>
            <Field className={"has-addons"}>
              <Control>
                <Input
                  type="text"
                  name="court_account_code"
                  onChange={handleChange}
                  value={contact.court_account_code}
                  disabled={true}
                />
              </Control>
              <Button
                  color={"info"}
                  onClick={() => fillCode("court_account_code")}
              >
                  Fill
              </Button>
            </Field>
          </Column>
          <Column></Column>
        </Columns>
        }
        <Columns isMultiline>
          <Column>
            <Title size="6">Workshop Instructions</Title>
            <Table>
              <thead>
              <tr>
                <th>Instruction</th>
                <th>On Completion of Job</th>
                <th>Remove</th>
              </tr>
              </thead>
              {contact.workshop_instructions.map((value, index) => (
                <Instruction
                  contact={contact.id}
                  key={value.id || value.key}
                  index={index}
                  instruction={value}
                  updateInstructions={updateWorkshopInstructions}
                  removeInstruction={removeWorkshopInstruction}
                  type={"Workshop"}
                />
              ))}
            </Table>
            <Columns isMultiline>
              <Column>
                <Button
                  id="add-workitem"
                  color="info"
                  onClick={addWorkshopInstruction}
                >
                  Add Workshop Instruction
                </Button>
              </Column>
            </Columns>
          </Column>
        </Columns>
        <Columns isMultiline>
          <Column>
            <Title size="6">Rental Instructions</Title>
            <Table>
              <thead>
              <tr>
                <th>Instruction</th>
                <th>Remove</th>
              </tr>
              </thead>
              {contact.rental_instructions.map((value, index) => (
                <Instruction
                  contact={contact.id}
                  key={value.id || value.key}
                  index={index}
                  instruction={value}
                  updateInstructions={updateRentalInstructions}
                  removeInstruction={removeRentalInstruction}
                  type={"Rental"}
                />
              ))}
            </Table>
            <Columns isMultiline>
              <Column>
                <Button
                  id="add-workitem"
                  color="info"
                  onClick={addRentalInstruction}
                >
                  Add Rental Instruction
                </Button>
              </Column>
            </Columns>
          </Column>
        </Columns>
        <Columns isMultiline>
          <Column>
            <Field className="has-addons">
              <Control>
                <label className="label">Status</label>
                <Button
                  color={!contact.accounts_active ? "primary" : ""}
                  onClick={() => setActive(false)}
                >
                  Inactive
                </Button>
                <Button
                  color={contact.accounts_active ? "primary" : ""}
                  onClick={() => setActive(true)}
                >
                  Active
                </Button>
              </Control>
            </Field>
          </Column>
          <Column>
              <label className="label">Account Form Sent</label>
              <Checkbox
                name={"accounts_form_sent"}
                checked={contact.accounts_form_sent}
                onChange={handleCheckbox}
              />
          </Column>
          <Column></Column>
          <Column></Column>
          <Column></Column>
        </Columns>
      </Box>
      <Box>
          <Columns isMultiline>
            <Column>
              <TextArea
                name={"free_text"}
                onChange={handleChange}
                value={contact.free_text}
              />
            </Column>
          </Columns>
      </Box>
      {contact.contact_type === "SP" && (
        <Box>
            <Title size="5">Primary Workshop Contact</Title>
            <Columns isMultiline>
              <Column>
                <Field>
                  <Control>
                    <label className="label">Name</label>
                    <Input
                      type="text"
                      name="workshop_name"
                      onChange={handleChange}
                      value={contact.workshop_name}
                    />
                  </Control>
                </Field>
              </Column>
              <Column>
                <Field>
                  <Control>
                    <label className="label">Phone Number</label>
                    <Input
                      type="text"
                      name="workshop_contact_number"
                      onChange={handleChange}
                      value={contact.workshop_contact_number}
                    />
                  </Control>
                </Field>
              </Column>
              <Column>
                <Field>
                  <Control>
                    <label className="label">Email</label>
                    <Input
                      type="email"
                      name="workshop_email"
                      onChange={handleChange}
                      value={contact.workshop_email}
                    />
                  </Control>
                </Field>
              </Column>
            </Columns>
            <Columns isMultiline>
              <Column>
                <Field>
                  <Control>
                    <label className="label">Comments</label>
                    <Input
                      type="text"
                      name="workshop_comments"
                      onChange={handleChange}
                      value={contact.workshop_comments}
                    />
                  </Control>
                </Field>
              </Column>
            </Columns>
            <Title size="5">Additional Workshop Contacts</Title>
            <ContactInfoSection
              contactList={contact.workshop_contacts}
              propertyName="workshop_contacts"
            />
        </Box>
      )}
      {contact.contact_type === "SP" && (
        <Box>
            <Title size="5">Primary Parts Contact</Title>
            <Columns isMultiline>
              <Column>
                <Field>
                  <Control>
                    <label className="label">Name</label>
                    <Input
                      type="text"
                      name="parts_name"
                      onChange={handleChange}
                      value={contact.parts_name}
                    />
                  </Control>
                </Field>
              </Column>
              <Column>
                <Field>
                  <Control>
                    <label className="label">Phone Number</label>
                    <Input
                      type="text"
                      name="parts_contact_number"
                      onChange={handleChange}
                      value={contact.parts_contact_number}
                    />
                  </Control>
                </Field>
              </Column>
              <Column>
                <Field>
                  <Control>
                    <label className="label">Email</label>
                    <Input
                      type="email"
                      name="parts_email"
                      onChange={handleChange}
                      value={contact.parts_email}
                    />
                  </Control>
                </Field>
              </Column>
            </Columns>
            <Columns isMultiline>
              <Column>
                <Field>
                  <Control>
                    <label className="label">Comments</label>
                    <Input
                      type="text"
                      name="parts_comments"
                      onChange={handleChange}
                      value={contact.parts_comments}
                    />
                  </Control>
                </Field>
              </Column>
            </Columns>
            <Title size="5">Additional Parts Contacts</Title>
            <ContactInfoSection
              contactList={contact.part_contacts}
              propertyName="part_contacts"
            />
        </Box>
      )}
      {contact.contact_type === "CC" && (<MovementDetails contact={contact} onChange={handleChange}/>)}
      {contact.contact_type === "CC" && (
        <Customer contact={contact} handleChange={handleChange} handleCheckbox={handleCheckbox} />
      )}
      {contact.contact_type === "SP" && (
        <Supplier contact={contact} handleChange={handleChange} handleCheckbox={handleCheckbox}/>
      )}
      {contact.contact_type === "CC" && contact.id && (
        <CustomerRentalRecord customer={contact.id} />
      )}
      {contact.is_cash_sale &&
        <CashSales data={contact.cash_sales}/>
      }
      <Box>
        <Field>
          <Control>
            <Button onClick={handleSubmit} type="submit" color="success" isFullWidth>
              Save Contact
            </Button>
          </Control>
        </Field>
        <Field>
          <Control>
            <Button disabled={contact.partial_contact} onClick={sendData} type="submit" color="info" isFullWidth>
              Send Data to Xero
            </Button>
          </Control>
        </Field>
        {contact.id && false && (
          <Field>
            <Control>
              <Button
                onClick={() => {
                  setModalOpen(true);
                }}
                type="submit"
                color="danger"
                isFullWidth
              >
                Delete Contact
              </Button>
            </Control>
          </Field>
        )}
      </Box>
      <DeleteWarningModal
        open={modalOpen}
        setOpen={setModalOpen}
        onDelete={handleDelete}
      />
      <TypeChangeModal
        open={typeModalOpen}
        setOpen={setTypeModalOpen}
        targetType={targetType}
      />
    </div>
  );
}

export default ContactForm;
